module.exports = __webpack_public_path__ + "img/symbol_6.b0a79f50.png";